import React from 'react'

export default function Card() {
  return (
    <>
      <h1>Card</h1>
      <p><span className='tag-grey bold'>.card</span> class creates a stylized card container  </p>

      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="card"&gt;<br/>
            &lt;div class="card-title"&gt; hhh &lt;/div&gt;<br/>
            &lt;div class="card-body"&gt;<br/>
                ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing<br/>
            &lt;/div&gt;<br/>
            &lt;div class="card-footer"&gt; hhh &lt;/div&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve'>
      <div className="card">
        <div className="card-title"> hhh </div>
        <div className="card-body">
            ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing
        </div>
        <div className="card-footer"> hhh </div>
        </div>
      </div>

      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="card card-dark"&gt;<br/>
            &lt;div class="card-title"&gt; hhh &lt;/div&gt;<br/>
            &lt;div class="card-body"&gt;<br/>
                ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing<br/>
            &lt;/div&gt;<br/>
            &lt;div class="card-footer"&gt; hhh &lt;/div&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve flex-align-xy'>
      <div className="card card-dark">
        <div className="card-title"> hhh </div>
        <div className="card-body">
            ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing
        </div>
        <div className="card-footer"> hhh </div>
        </div>
      </div>

      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="card card-grey"&gt;<br/>
            &lt;div class="card-title"&gt; hhh &lt;/div&gt;<br/>
            &lt;div class="card-body"&gt;<br/>
                ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing<br/>
            &lt;/div&gt;<br/>
            &lt;div class="card-footer"&gt; hhh &lt;/div&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve flex-align-xy'>
      <div className="card card-grey">
        <div className="card-title"> hhh </div>
        <div className="card-body">
            ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing
        </div>
        <div className="card-footer"> hhh </div>
        </div>
      </div>

      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="card card-dgrey"&gt;<br/>
            &lt;div class="card-title"&gt; hhh &lt;/div&gt;<br/>
            &lt;div class="card-body"&gt;<br/>
                ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing<br/>
            &lt;/div&gt;<br/>
            &lt;div class="card-footer"&gt; hhh &lt;/div&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve flex-align-xy'>
      <div className="card card-dgrey">
        <div className="card-title"> hhh </div>
        <div className="card-body">
            ths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing -sized student-formed group learning in order to promote group learning while reducing the incidence of social-loafing
        </div>
        <div className="card-footer"> hhh </div>
        </div>
      </div>
    </>
  )
}
